import { render } from "./MyProfileBanner.vue?vue&type=template&id=6daa7c78"
import script from "./MyProfileBanner.vue?vue&type=script&lang=js"
export * from "./MyProfileBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__